/* Promo bar — multilingual announcement + minimalist countdown.
 * Reads window.PROMO_BAR (injected by promo-bar-data.liquid, rewritten per
 * active promo by the Промоции module) and window.PROMO_BAR_LOCALE (theme locale).
 * Self-contained: localized unit labels live here, so no theme locale edits. */
(function () {
  'use strict';

  // localized labels for the 10 storefront locales: [singular, plural]
  var LABELS = {
    bg: { left: 'Остават', ended: 'Промоцията изтече', d: ['ден', 'дни'], h: ['час', 'часа'], m: ['минута', 'минути'], s: ['секунда', 'секунди'] },
    en: { left: 'Ends in', ended: 'Promotion ended', d: ['day', 'days'], h: ['hour', 'hours'], m: ['min', 'min'], s: ['sec', 'sec'] },
    de: { left: 'Endet in', ended: 'Aktion beendet', d: ['Tag', 'Tage'], h: ['Std', 'Std'], m: ['Min', 'Min'], s: ['Sek', 'Sek'] },
    el: { left: 'Λήγει σε', ended: 'Η προσφορά έληξε', d: ['ημέρα', 'ημέρες'], h: ['ώρα', 'ώρες'], m: ['λεπτό', 'λεπτά'], s: ['δευτ.', 'δευτ.'] },
    es: { left: 'Termina en', ended: 'Promoción finalizada', d: ['día', 'días'], h: ['hora', 'horas'], m: ['min', 'min'], s: ['seg', 'seg'] },
    fr: { left: 'Se termine dans', ended: 'Promotion terminée', d: ['jour', 'jours'], h: ['h', 'h'], m: ['min', 'min'], s: ['sec', 'sec'] },
    hr: { left: 'Završava za', ended: 'Promocija je istekla', d: ['dan', 'dana'], h: ['sat', 'sati'], m: ['min', 'min'], s: ['sek', 'sek'] },
    hu: { left: 'Vége', ended: 'Az akció lejárt', d: ['nap', 'nap'], h: ['óra', 'óra'], m: ['perc', 'perc'], s: ['mp', 'mp'] },
    it: { left: 'Termina tra', ended: 'Promozione terminata', d: ['giorno', 'giorni'], h: ['ora', 'ore'], m: ['min', 'min'], s: ['sec', 'sec'] },
    ro: { left: 'Se termină în', ended: 'Promoția a expirat', d: ['zi', 'zile'], h: ['oră', 'ore'], m: ['min', 'min'], s: ['sec', 'sec'] },
  };

  var DATA = window.PROMO_BAR;
  var root = document.getElementById('promo-bar-root');
  if (!root || !DATA || (!DATA.announcement && !DATA.countdown)) { if (root) root.remove(); return; }

  var loc = String(window.PROMO_BAR_LOCALE || 'en').toLowerCase().split('-')[0];
  var L = LABELS[loc] || LABELS.en;
  var texts = DATA.texts || {};
  var text = texts[loc] || texts.en || texts[Object.keys(texts)[0]] || '';

  function unit(n, pair) { return n + ' ' + (n === 1 ? pair[0] : pair[1]); }
  function fmt(ms) {
    if (ms < 0) ms = 0;
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    var parts = [];
    if (d > 0) parts.push(unit(d, L.d));
    parts.push(unit(h, L.h), unit(m, L.m), unit(s, L.s));
    return L.left + ': ' + parts.join(', ');
  }

  var bar = document.createElement('div');
  bar.className = 'promo-bar';
  if (DATA.announcement && text) {
    var msg = document.createElement('span');
    msg.className = 'promo-bar__msg';
    msg.textContent = text;
    bar.appendChild(msg);
  }
  var clock = null;
  if (DATA.countdown && DATA.endAt) {
    clock = document.createElement('span');
    clock.className = 'promo-bar__clock';
    bar.appendChild(clock);
  }
  root.appendChild(bar);
  document.documentElement.classList.add('has-promo-bar');

  if (clock) {
    var end = new Date(DATA.endAt).getTime();
    var timer;
    var tick = function () {
      var diff = end - Date.now();
      if (diff <= 0) { clock.textContent = L.ended; clearInterval(timer); return; }
      clock.textContent = fmt(diff);
    };
    tick();
    timer = setInterval(tick, 1000);
  }
})();
